export default {
  playgrounds: [],
  selectedBlockPrices: [],
  blockPricesTotalItems: null,
  selectedTimetables: [],
  timetablesTotalItems: null,
  loader: true,
  clubTimetables: [],
}
